import { useState } from 'react'
import styled from 'styled-components'
import {
  Modal,
  Text,
  Flex,
  Image,
  Button,
  Slider,
  BalanceInput,
  AutoRenewIcon,
  CalculateIcon,
  IconButton,
  Skeleton,
} from '@pancakeswap/uikit'
import BigNumber from 'bignumber.js'


// min deposit and withdraw amount
const MIN_AMOUNT = new BigNumber(10000000000000)

interface VaultStakeModalProps {
  pool: any
  stakingMax: BigNumber
  performanceFee?: number
  isRemovingStake?: boolean
  onDismiss?: () => void
}

const StyledButton = styled(Button)`
  flex-grow: 1;
`

const AnnualRoiContainer = styled(Flex)`
  cursor: pointer;
`

const AnnualRoiDisplay = styled(Text)`
  width: 72px;
  max-width: 72px;
  overflow: hidden;
  text-align: right;
  text-overflow: ellipsis;
`

const VaultStakeModal: React.FC<VaultStakeModalProps> = ({
  pool,
  stakingMax,
  performanceFee,
  isRemovingStake = false,
  onDismiss,
}) => {


  return (
    <Modal
      title={isRemovingStake ? ('Unstake') : ('Stake in Pool')}
      onDismiss={onDismiss}
    >
      <Flex alignItems="center" justifyContent="space-between" mb="8px">
        <Text bold>{isRemovingStake ? ('Unstake') : ('Stake')}:</Text>
        <Flex alignItems="center" minWidth="70px">
          {/* <Image src={`/images/tokens/${stakingToken.address}.png`} width={24} height={24} alt={stakingToken.symbol} /> */}
          <Text ml="4px" bold>
            Driven
          </Text>
        </Flex>
      </Flex>
     
      <Text mt="8px" ml="auto" color="textSubtle" fontSize="12px" mb="8px">
        {/* {('Balance: %balance%', { balance: getFullDisplayBalance(stakingMax, stakingToken.decimals) })} */}
      </Text>
      
      <Flex alignItems="center" justifyContent="space-between" mt="8px">
        <StyledButton scale="xs" mx="2px" p="4px 16px" variant="tertiary" >
          25%
        </StyledButton>
        <StyledButton scale="xs" mx="2px" p="4px 16px" variant="tertiary" >
          50%
        </StyledButton>
        <StyledButton scale="xs" mx="2px" p="4px 16px" variant="tertiary" >
          75%
        </StyledButton>
        <StyledButton scale="xs" mx="2px" p="4px 16px" variant="tertiary" >
          {('Max')}
        </StyledButton>
      </Flex>
      {/* {isRemovingStake && hasUnstakingFee && (
        <FeeSummary vaultKey={vaultKey} stakingTokenSymbol={stakingToken.symbol} stakeAmount={stakeAmount} />
      )} */}
      {!isRemovingStake && (
        <Flex mt="24px" alignItems="center" justifyContent="space-between">
          <Text mr="8px" color="textSubtle">
            {('Annual ROI at current rates')}:
          </Text>
          {/* {Number.isFinite(annualRoi) ? ( */}
          <AnnualRoiContainer
            alignItems="center"
          // onClick={() => {
          //   setShowRoiCalculator(true)
          // }}
          >
            <AnnualRoiDisplay>Annual</AnnualRoiDisplay>
            <IconButton variant="text" scale="sm">
              <CalculateIcon color="textSubtle" width="18px" />
            </IconButton>
          </AnnualRoiContainer>
          {/* ) : (
          <Skeleton width={60} />
          )} */}
        </Flex>
      )}
      <Button
        // isLoading={pendingTx}
        // endIcon={pendingTx ? <AutoRenewIcon spin color="currentColor" /> : null}
        // onClick={handleConfirmClick}
        // disabled={!stakeAmount || parseFloat(stakeAmount) === 0 || stakingMax.lt(convertedStakeAmount)}
        mt="24px"
      >
        Confirm
      </Button>
      {
        !isRemovingStake && (
          <Button mt="8px" as="a" variant="secondary">
            Driven
          </Button>
        )
      }
    </Modal >
  )
}

export default VaultStakeModal
